import { c as _c } from "react/compiler-runtime";
import React from "react";
import { State } from "../../../store/state";
import { useWidgetDispatch, useWidgetSelector } from "../../../store/store";
import { NumericFormat } from "react-number-format";
import Link from "next/link";
import { usePlausible } from "next-plausible";
import AnimateHeight from "react-animate-height";
import { CauseArea } from "../../../types/CauseArea";
import { ShareType } from "../../../types/Enums";
import { setCauseAreaAmount, setOrgAmount, setCauseAreaDistributionType, setOperationsPercentageModeByCauseArea, setOperationsPercentageByCauseArea, setShowAllOrganizations, setHasManuallyEditedPrefilledOrgAmount } from "../../../store/actions";
import { thousandize } from "../../../../../../../util/formatting";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { RadioButtonGroup } from "../../../../RadioButton/RadioButtonGroup";
import { CustomCheckBox } from "../DonorPane/CustomCheckBox";
import { OperationsConfig, CauseAreaDisplayConfig, SmartDistributionContext } from "../../../types/WidgetProps";
import { CauseAreaRollout } from "../../shared/CauseAreaRollout/CauseAreaRollout";
import { splitOperationsLabelTemplate } from "../../../utils/operationsLabel";
import { useIsMobile } from "../../../../../../../hooks/useIsMobile";
import { splitAmountByShares, standardShareByOrgId } from "../../../utils/donationCalculations";
import styles from "../AmountPane.module.scss";
import forms from "../Forms.module.scss";
import { getCauseAreaIconById } from "../../shared/CauseAreaIcon/CauseAreaIcon";
interface CauseAreaFormProps {
  causeArea: CauseArea;
  isSingleSelection: boolean;
  suggestedSums: Array<{
    amount: number;
    subtext?: string;
  }>;
  causeAreaAmounts: Record<number, number>;
  orgAmounts: Record<number, number>;
  causeAreaDistributionType: Record<number, ShareType>;
  showOperationsOption?: boolean;
  operationsConfig?: OperationsConfig;
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  smartDistributionContext: SmartDistributionContext;
}
export const CauseAreaForm: React.FC<CauseAreaFormProps> = t0 => {
  const $ = _c(88);
  const {
    causeArea,
    isSingleSelection,
    suggestedSums,
    causeAreaAmounts,
    orgAmounts,
    causeAreaDistributionType,
    showOperationsOption: t1,
    operationsConfig,
    causeAreaDisplayConfig,
    smartDistributionContext
  } = t0;
  const showOperationsOption = t1 === undefined ? false : t1;
  const dispatch = useWidgetDispatch();
  const plausible = usePlausible();
  const isMobile = useIsMobile();
  const hasSingleOrg = causeArea.organizations.length <= 1;
  const isOtherCauseArea = causeArea.id === 5;
  const hideDistributionToggle = hasSingleOrg || isOtherCauseArea;
  const currentCauseAreaAmount = causeAreaAmounts[causeArea.id] || 0;
  const {
    operationsPercentageModeByCauseArea: t2,
    operationsPercentageByCauseArea: t3,
    operationsConfig: stateConfig,
    prefilledShares: t4,
    showAllOrganizations: t5,
    hasManuallyEditedPrefilledOrgAmount: t6
  } = useWidgetSelector(_temp);
  let t7;
  if ($[0] !== t2) {
    t7 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const operationsPercentageModeByCauseArea = t7;
  let t8;
  if ($[2] !== t3) {
    t8 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const operationsPercentageByCauseArea = t8;
  const prefilledShares = t4 === undefined ? null : t4;
  const showAllOrganizations = t5 === undefined ? false : t5;
  const hasManuallyEditedPrefilledOrgAmount = t6 === undefined ? false : t6;
  let currentPercentage;
  let handleCutToggle;
  let handlePercentageChange;
  let isOperationsEnabled;
  let operationsLabelPrefix;
  let operationsLabelSuffix;
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[4] !== causeArea || $[5] !== causeAreaAmounts || $[6] !== causeAreaDisplayConfig || $[7] !== causeAreaDistributionType || $[8] !== currentCauseAreaAmount || $[9] !== dispatch || $[10] !== hasManuallyEditedPrefilledOrgAmount || $[11] !== hasSingleOrg || $[12] !== hideDistributionToggle || $[13] !== isMobile || $[14] !== isSingleSelection || $[15] !== operationsConfig || $[16] !== operationsPercentageByCauseArea || $[17] !== operationsPercentageModeByCauseArea || $[18] !== orgAmounts || $[19] !== plausible || $[20] !== prefilledShares || $[21] !== showAllOrganizations || $[22] !== smartDistributionContext || $[23] !== stateConfig?.defaultPercentage || $[24] !== suggestedSums) {
    const activeOrganizations = causeArea.organizations.filter(_temp2).sort(_temp3);
    let t13;
    if ($[35] !== prefilledShares) {
      t13 = organization_0 => prefilledShares?.[organization_0.id] !== undefined;
      $[35] = prefilledShares;
      $[36] = t13;
    } else {
      t13 = $[36];
    }
    const hasPrefilledOrganizations = activeOrganizations.some(t13);
    const isTrackingPrefilledShares = hasPrefilledOrganizations && !hasManuallyEditedPrefilledOrgAmount;
    const visibleOrganizations = hasPrefilledOrganizations && !showAllOrganizations ? activeOrganizations.filter(organization_1 => prefilledShares?.[organization_1.id] !== undefined) : activeOrganizations;
    const defaultPercentage = operationsConfig ? 5 : stateConfig?.defaultPercentage ?? 5;
    currentPercentage = operationsPercentageByCauseArea[causeArea.id] ?? defaultPercentage;
    const t14 = operationsConfig?.operations_label_template;
    let t15;
    if ($[37] !== t14) {
      t15 = splitOperationsLabelTemplate(t14);
      $[37] = t14;
      $[38] = t15;
    } else {
      t15 = $[38];
    }
    ({
      prefix: operationsLabelPrefix,
      suffix: operationsLabelSuffix
    } = t15);
    isOperationsEnabled = operationsPercentageModeByCauseArea[causeArea.id] ?? false;
    const inputValue = currentCauseAreaAmount;
    let t16;
    if ($[39] !== causeArea.id || $[40] !== dispatch) {
      t16 = checked => {
        dispatch(setOperationsPercentageModeByCauseArea(causeArea.id, checked));
      };
      $[39] = causeArea.id;
      $[40] = dispatch;
      $[41] = t16;
    } else {
      t16 = $[41];
    }
    handleCutToggle = t16;
    let t17;
    if ($[42] !== causeArea.id || $[43] !== dispatch) {
      t17 = (values, sourceInfo) => {
        if (sourceInfo.source !== "event") {
          return;
        }
        const v = values.floatValue === undefined ? 0 : values.floatValue;
        const limitedPercentage = Math.min(Math.max(v, 0), 100);
        dispatch(setOperationsPercentageByCauseArea(causeArea.id, limitedPercentage));
      };
      $[42] = causeArea.id;
      $[43] = dispatch;
      $[44] = t17;
    } else {
      t17 = $[44];
    }
    handlePercentageChange = t17;
    const setTrackedOrganizationAmounts = amount => {
      if (!isTrackingPrefilledShares || !prefilledShares) {
        return;
      }
      const trackedShares = causeArea.organizations.filter(organization_2 => prefilledShares[organization_2.id] !== undefined);
      const amountByOrgId = splitAmountByShares(amount, Object.fromEntries(trackedShares.map(org => [org.id, prefilledShares[org.id]])));
      trackedShares.forEach(organization_3 => {
        dispatch(setOrgAmount(organization_3.id, amountByOrgId[organization_3.id] ?? 0));
      });
    };
    let t18;
    if ($[45] !== causeArea.id || $[46] !== causeArea.organizations[0] || $[47] !== dispatch || $[48] !== hasSingleOrg || $[49] !== setTrackedOrganizationAmounts) {
      t18 = (values_0, sourceInfo_0) => {
        if (sourceInfo_0.source !== "event") {
          return;
        }
        const v_0 = values_0.floatValue === undefined ? 0 : values_0.floatValue;
        dispatch(setCauseAreaAmount(causeArea.id, v_0));
        if (hasSingleOrg) {
          dispatch(setOrgAmount(causeArea.organizations[0].id, v_0));
        } else {
          setTrackedOrganizationAmounts(v_0);
        }
      };
      $[45] = causeArea.id;
      $[46] = causeArea.organizations[0];
      $[47] = dispatch;
      $[48] = hasSingleOrg;
      $[49] = setTrackedOrganizationAmounts;
      $[50] = t18;
    } else {
      t18 = $[50];
    }
    const handleAmountChange = t18;
    let t19;
    if ($[51] !== causeArea.id || $[52] !== causeArea.organizations[0] || $[53] !== dispatch || $[54] !== hasSingleOrg || $[55] !== plausible || $[56] !== setTrackedOrganizationAmounts) {
      t19 = amount_0 => {
        plausible("SelectSuggestedSum", {
          props: {
            sum: amount_0
          }
        });
        dispatch(setCauseAreaAmount(causeArea.id, amount_0));
        if (hasSingleOrg) {
          dispatch(setOrgAmount(causeArea.organizations[0].id, amount_0));
        } else {
          setTrackedOrganizationAmounts(amount_0);
        }
      };
      $[51] = causeArea.id;
      $[52] = causeArea.organizations[0];
      $[53] = dispatch;
      $[54] = hasSingleOrg;
      $[55] = plausible;
      $[56] = setTrackedOrganizationAmounts;
      $[57] = t19;
    } else {
      t19 = $[57];
    }
    const handleSuggestedSumClick = t19;
    t9 = styles.formWrapper;
    t10 = causeArea.id;
    let t20;
    if ($[58] !== causeArea.id) {
      t20 = getCauseAreaIconById(causeArea.id);
      $[58] = causeArea.id;
      $[59] = t20;
    } else {
      t20 = $[59];
    }
    const t21 = causeArea.widgetDisplayName || causeArea.name;
    let t22;
    if ($[60] !== t20 || $[61] !== t21) {
      t22 = <div className={styles.causeAreaTitle}>{t20}{t21}</div>;
      $[60] = t20;
      $[61] = t21;
      $[62] = t22;
    } else {
      t22 = $[62];
    }
    let t23;
    if ($[63] !== causeArea.id || $[64] !== causeAreaDisplayConfig) {
      t23 = getCauseAreaContext(causeArea.id, causeAreaDisplayConfig) && <div className={styles.causeAreaContext}>{getCauseAreaContext(causeArea.id, causeAreaDisplayConfig)}</div>;
      $[63] = causeArea.id;
      $[64] = causeAreaDisplayConfig;
      $[65] = t23;
    } else {
      t23 = $[65];
    }
    if ($[66] !== t22 || $[67] !== t23) {
      t11 = <div>{t22}{t23}</div>;
      $[66] = t22;
      $[67] = t23;
      $[68] = t11;
    } else {
      t11 = $[68];
    }
    t12 = <div>{hideDistributionToggle ? <div className={styles.totalSumWrapper}>{isSingleSelection && <div className={styles.sumButtonsWrapper}>{suggestedSums.map(suggested => <div key={suggested.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={inputValue === suggested.amount} onClick={() => handleSuggestedSumClick(suggested.amount)} noMinWidth={true} data-cy={`suggested-sum-${causeArea.id}-${suggested.amount}`}>{`${suggested.amount ? thousandize(suggested.amount) : "-"} kr`}</EffektButton>{suggested.subtext && <i>{suggested.subtext}</i>}</div>)}</div>}<div className={styles.sumWrapper}><span><NumericFormat name={`sum-${causeArea.id}`} thousandSeparator=" " allowNegative={false} decimalScale={0} type="tel" placeholder="0" value={inputValue > 0 ? inputValue : ""} autoComplete="off" data-cy={`donation-sum-input-${causeArea.id}`} onValueChange={handleAmountChange} /></span></div></div> : <><AnimateHeight height={causeAreaDistributionType[causeArea.id] === ShareType.STANDARD || causeAreaDistributionType[causeArea.id] === undefined ? "auto" : 0} animateOpacity={true} duration={300}><div style={{
            paddingBottom: "30px"
          }}><div className={styles.totalSumWrapper}>{isSingleSelection && <div className={styles.sumButtonsWrapper}>{suggestedSums.map(suggested_0 => <div key={suggested_0.amount}><EffektButton variant={EffektButtonVariant.SECONDARY} selected={inputValue === suggested_0.amount} onClick={() => handleSuggestedSumClick(suggested_0.amount)} noMinWidth={true} data-cy={`suggested-sum-${causeArea.id}-${suggested_0.amount}`}>{`${suggested_0.amount ? thousandize(suggested_0.amount) : "-"} kr`}</EffektButton>{suggested_0.subtext && <i>{suggested_0.subtext}</i>}</div>)}</div>}<div className={styles.sumWrapper}><span><NumericFormat name={`sum-${causeArea.id}`} type="tel" placeholder="0" thousandSeparator=" " value={inputValue > 0 ? inputValue : ""} allowNegative={false} step={1} decimalScale={0} autoComplete="off" data-cy={`donation-sum-input-${causeArea.id}`} onValueChange={handleAmountChange} /></span></div></div></div></AnimateHeight><RadioButtonGroup options={[{
          title: smartDistributionContext.smart_distribution_radiobutton_text,
          value: ShareType.STANDARD,
          data_cy: `radio-smart-share-${causeArea.id}`
        }, {
          title: smartDistributionContext.custom_distribution_radiobutton_text,
          value: ShareType.CUSTOM,
          data_cy: `radio-custom-share-${causeArea.id}`,
          content: <div className={styles.inputList}>{visibleOrganizations.map(org_0 => <div className={styles.organizationInputWrapper} key={org_0.id}><Link href={org_0.informationUrl || "#"} target={isMobile ? "_blank" : undefined} rel={isMobile ? "noopener noreferrer" : undefined}>{org_0.widgetDisplayName || org_0.name}</Link><span><NumericFormat id={`org-${org_0.id}`} aria-label={org_0.widgetDisplayName || org_0.name} type="tel" placeholder="0" value={orgAmounts[org_0.id] || ""} step={1} decimalScale={0} allowNegative={false} thousandSeparator=" " autoComplete="off" data-cy={`org-${org_0.id}`} onValueChange={(values_1, sourceInfo_1) => {
                  if (sourceInfo_1.source !== "event") {
                    return;
                  }
                  const v_1 = values_1.floatValue === undefined ? 0 : values_1.floatValue;
                  if (prefilledShares?.[org_0.id] !== undefined) {
                    dispatch(setHasManuallyEditedPrefilledOrgAmount(true));
                  }
                  dispatch(setOrgAmount(org_0.id, v_1));
                }} /></span></div>)}{hasPrefilledOrganizations && !showAllOrganizations && <EffektButton variant={EffektButtonVariant.SECONDARY} onClick={() => dispatch(setShowAllOrganizations(true))} data-cy="show-all-organizations-button">{smartDistributionContext.show_all_organizations_text} ↓</EffektButton>}</div>
        }]} selected={causeAreaDistributionType[causeArea.id] ?? ShareType.STANDARD} onSelect={val => {
          dispatch(setCauseAreaDistributionType(causeArea.id, val));
          if (val === ShareType.CUSTOM) {
            const hasSetOrgAmounts = Object.entries(orgAmounts).filter(t24 => {
              const [key, value] = t24;
              const orgId = parseInt(key);
              return value > 0 && causeArea.organizations.some(org_1 => org_1.id === orgId);
            }).length > 0;
            if (!hasSetOrgAmounts) {
              const amountByOrgId_0 = splitAmountByShares(causeAreaAmounts[causeArea.id] || 0, standardShareByOrgId(causeArea));
              for (const org_2 of causeArea.organizations) {
                if (!org_2.standardShare) {
                  continue;
                }
                dispatch(setOrgAmount(org_2.id, amountByOrgId_0[org_2.id] ?? 0));
              }
            }
          }
        }} /></>}</div>;
    $[4] = causeArea;
    $[5] = causeAreaAmounts;
    $[6] = causeAreaDisplayConfig;
    $[7] = causeAreaDistributionType;
    $[8] = currentCauseAreaAmount;
    $[9] = dispatch;
    $[10] = hasManuallyEditedPrefilledOrgAmount;
    $[11] = hasSingleOrg;
    $[12] = hideDistributionToggle;
    $[13] = isMobile;
    $[14] = isSingleSelection;
    $[15] = operationsConfig;
    $[16] = operationsPercentageByCauseArea;
    $[17] = operationsPercentageModeByCauseArea;
    $[18] = orgAmounts;
    $[19] = plausible;
    $[20] = prefilledShares;
    $[21] = showAllOrganizations;
    $[22] = smartDistributionContext;
    $[23] = stateConfig?.defaultPercentage;
    $[24] = suggestedSums;
    $[25] = currentPercentage;
    $[26] = handleCutToggle;
    $[27] = handlePercentageChange;
    $[28] = isOperationsEnabled;
    $[29] = operationsLabelPrefix;
    $[30] = operationsLabelSuffix;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t9;
  } else {
    currentPercentage = $[25];
    handleCutToggle = $[26];
    handlePercentageChange = $[27];
    isOperationsEnabled = $[28];
    operationsLabelPrefix = $[29];
    operationsLabelSuffix = $[30];
    t10 = $[31];
    t11 = $[32];
    t12 = $[33];
    t9 = $[34];
  }
  let t13;
  if ($[69] !== causeArea.id || $[70] !== currentPercentage || $[71] !== handleCutToggle || $[72] !== handlePercentageChange || $[73] !== isOperationsEnabled || $[74] !== operationsLabelPrefix || $[75] !== operationsLabelSuffix || $[76] !== showOperationsOption) {
    t13 = showOperationsOption && <div><div style={{
        display: "flex",
        alignItems: "center",
        gap: "10px"
      }}><div className={forms.checkBoxWrapper}><input className={forms.hiddenCheckBox} type="checkbox" checked={isOperationsEnabled} onChange={e => handleCutToggle(e.target.checked)} data-cy={`cut-checkbox-${causeArea.id}`} /><CustomCheckBox checked={isOperationsEnabled} label="" /></div><div className={styles.operationsPercentageInputWrapper}>{operationsLabelPrefix && <span>{operationsLabelPrefix}</span>}<span><NumericFormat name={`percentage-cut-${causeArea.id}`} allowNegative={false} decimalScale={1} max={100} type="tel" placeholder="5" value={currentPercentage} autoComplete="off" data-cy={`percentage-cut-input-${causeArea.id}`} onValueChange={handlePercentageChange} disabled={!isOperationsEnabled} /></span>{operationsLabelSuffix && <span>{operationsLabelSuffix}</span>}</div></div></div>;
    $[69] = causeArea.id;
    $[70] = currentPercentage;
    $[71] = handleCutToggle;
    $[72] = handlePercentageChange;
    $[73] = isOperationsEnabled;
    $[74] = operationsLabelPrefix;
    $[75] = operationsLabelSuffix;
    $[76] = showOperationsOption;
    $[77] = t13;
  } else {
    t13 = $[77];
  }
  let t14;
  if ($[78] !== causeArea.id || $[79] !== causeAreaDisplayConfig) {
    t14 = <CauseAreaRollout causeAreaId={causeArea.id} config={causeAreaDisplayConfig} />;
    $[78] = causeArea.id;
    $[79] = causeAreaDisplayConfig;
    $[80] = t14;
  } else {
    t14 = $[80];
  }
  let t15;
  if ($[81] !== t10 || $[82] !== t11 || $[83] !== t12 || $[84] !== t13 || $[85] !== t14 || $[86] !== t9) {
    t15 = <div className={t9} key={t10}>{t11}{t12}{t13}{t14}</div>;
    $[81] = t10;
    $[82] = t11;
    $[83] = t12;
    $[84] = t13;
    $[85] = t14;
    $[86] = t9;
    $[87] = t15;
  } else {
    t15 = $[87];
  }
  return t15;
};
const getCauseAreaContext = (id: number, config?: CauseAreaDisplayConfig) => {
  const context = config?.cause_area_contexts?.find(c => c.cause_area_id === id);
  return context?.context_text || null;
};
function _temp(state) {
  return state.donation;
}
function _temp2(organization) {
  return organization.isActive;
}
function _temp3(first, second) {
  return first.ordering - second.ordering;
}